export enum PurchaseOrderReferenceNumberType {
  RedeliveryReferenceNumber = 'redeliveryReferenceNumber',
  VendorReleaseReferenceNumber = 'vendorReleaseReferenceNumber',
}
